"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = exports.ImageConfig = exports.Thumbnail = exports.ImageFieldType = void 0;
const tslib_1 = require("tslib");
const t = (0, tslib_1.__importStar)(require("io-ts"));
const validators_1 = require("../../../validators");
const ImageConstraint_1 = (0, tslib_1.__importDefault)(require("../shared/ImageConstraint"));
exports.ImageFieldType = "Image";
exports.Thumbnail = t.exact(t.intersection([
    t.type({
        name: t.string,
    }),
    ImageConstraint_1.default,
]));
exports.ImageConfig = t.exact(t.partial({
    label: validators_1.StringOrNull,
    placeholder: t.string,
    constraint: ImageConstraint_1.default,
    thumbnails: t.readonlyArray(exports.Thumbnail),
}));
exports.Image = t.exact(t.intersection([
    t.type({
        type: t.literal(exports.ImageFieldType),
    }),
    t.partial({
        fieldset: validators_1.StringOrNull,
        config: exports.ImageConfig,
    }),
]));
